<ng-container *ngIf="!isDeliveryConfirmation">
  <div *ngIf="deliveryCurrent" class="basket-confirm">

    <app-delivery-list
      [deliveryCurrent]="deliveryCurrent"
      [deliveryList]="deliveryList"
      [wars]="wars"
      (deliveryChange)="switchesDeliveryType($event)"
    />

    <div class="del-type">
      <div class="del-type-comment"
           [innerHTML]="deliveryCurrent.comment"
      ></div>

      <div class="del-type-delivery-city">
        <label>Місто</label>
        <div>
          <select
            [class.border-wrong]="wrongDeliveryCityId"
            [(ngModel)]="deliveryCityId"
            (change)="setDeliveryCity()"
          >
            <option value="-1">Вкажіть місто</option>
            <option *ngFor="let city of deliveryCities" [value]="city.id">
              {{ city.city }}
            </option>
          </select>
          <span class="status-error" *ngIf="wrongDeliveryCityId">Вкажіть місто</span>
        </div>
      </div>
      <div class="del-type-delivery-warehouse">
        <label>Номер відділення</label>
        <div>
          <select
            #scrollInputRef
            [class.border-wrong]="wrongDeliveryWarehouse"
            [(ngModel)]="deliveryWarehouse"
            (change)="setDeliveryWarehouse()"
          >
            <option value="-1">Вкажіть номер відділення</option>
            <option *ngFor="let war of warehouses" [value]="war.id">{{ war.name }}</option>
          </select>
          <span class="status status-error" *ngIf="wrongDeliveryWarehouse">Вкажіть відділення</span>
        </div>
      </div>

      <div class="del-type-delivery-is-address">
        <div class="flex-container">
          <label
            class="del-type-delivery-address-branch"
            [class.active]="!isDeliveryAddress"
            (click)="setIsDeliveryAddress()"
          >
            У відділення
          </label>
          <span class="address-desktop">Адресна доставка</span>
          <span class="address-mobile">Адресна</span>
          <label
            *ngIf="addressedDelivery"
            class="del-type-delivery-address-name"
            [class.active]="isDeliveryAddress"
            (click)="setIsDeliveryAddress()"
          >
          </label>
        </div>
      </div>
      <div *ngIf="isDeliveryAddress" class="del-type-delivery-address">
        <label>Адреса</label>
        <div>
          <input
            type="text"
            placeholder="Адреса"
            [class.border-wrong]="wrongDeliveryAddres"
            [(ngModel)]="deliveryAddress"
            (input)="inputDeliveryAddressChange()"
          >
          <button type="button" *ngIf="deliveryAddress !== '' && deliveryAddress !== null" class="cross-clears" (click)="crossClearAddress()"></button>
          <span class="status-error" *ngIf="wrongDeliveryAddres">Введіть адресу доставки</span>
        </div>
      </div>
      <div *ngIf="!activeOrganization || activeOrganization.type === 'fiz'" class="del-type-delivery-price">
        <label>Оціночна вартість замовлення</label>
        <div>
          <input
            type="number"
            [class.border-wrong]="wrongEstimateOfTheCostOfTheOrder"
            [(ngModel)]="declaredPrice"
            (input)="inputEstimateOfTheCostOfTheOrder()"
          >
          <button type="button" *ngIf="declaredPrice !== '' && declaredPrice !== null" class="cross-clears" (click)="crossClearPrice()"></button>
          <span class="status-error" *ngIf="wrongEstimateOfTheCostOfTheOrder">Введіть вартість замовлення</span>
        </div>
      </div>

      <div *ngIf="!user.allow_reserve_order" class="activation-text">
        <p>Для активації «резерв» будь ласка <br> зверніться до адміністратора сайту.</p>
      </div>

      <div *ngIf="!user.del_allow_beznal" class="activation-text">
        <p>Для активації «Безготівкова оплата доставки» <br> будь ласка зверніться до адміністратора сайту.</p>
      </div>

      <div *ngIf="user.allow_reserve_order" class="info-position-delivery">
          <i class="fa fa-info-circle" (click)="reserveInfoMessage()">
            <div class="bulb-info-message" [class.show-tooltip]="reserveInfoMessageShow">
              <div class="bulbarrow"></div>
              <p *ngIf="reserveTimeOk" class="appears-tooltip">
                Ви можете поставити замовлення у резерв до 16:30, щоб відтермінувати відправку
              </p>
              <p *ngIf="!reserveTimeOk" class="appears-tooltip">
                Замовлення можна резервувати до 16:30 поточного дня
              </p>
            </div>
          </i>
        <div class="reserve-activation-title">
          Резерв
        </div>
        <div class="checkbox-reserve">
          <label *ngIf="reserveTimeOk"
                 [class.active]="reserve"
                 (click)="deliveryGoodsReserve()">
          </label>
        </div>
      </div>

      <ng-container *ngIf="user.del_allow_beznal">
        <div class="del-type-delivery-beznal">
          <label [class.active]="deliveryBeznal" (click)="setDeliveryBeznal()">
            Безготівкова оплата доставки
          </label>
        </div>
        <div *ngIf="deliveryBeznal" class="del-type-delivery-edrpou">
          <label>ЕДРПОУ/РНОКПП</label>
          <div>
            <div>
              <input
                type="text"
                inputmode="numeric"
                placeholder="ЕДРПОУ/РНОКПП"
                [class.border-wrong]="wrongLastAddressEdrpou"
                [(ngModel)]="lastAddress.edrpou"
                (input)="inputLastAddressEdrpou()"
              >
              <button type="button" *ngIf="lastAddress.edrpou !== '' && lastAddress.edrpou !== null" class="cross-clears" (click)="crossClearAddressEdrpou()"></button>
              <span class="status"
                    [class.status-error]="wrongLastAddressEdrpou">Заповніть реквизити</span>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="del-type-delivery-info">
        <h3>Інформация одержувача</h3>
      </div>
      <div class="del-type-delivery-lastname">
        <label>Прізвище</label>
        <div>
          <input
            type="text"
            placeholder="Прізвище одержувача"
            [class.border-wrong]="wrongLastName"
            [(ngModel)]="lastName"
            (input)="inputLastName()"
          >
          <button type="button" *ngIf="lastName !== ''" class="cross-clears" (click)="crossClearLastName()"></button>
          <span class="status" [class.status-error]="wrongLastName">{{ errorMessageLastName }}</span>
        </div>
      </div>
      <div class="del-type-delivery-firstname">
        <label>Ім'я</label>
        <div>
          <input
            type="text"
            placeholder="Ім'я одержувача"
            [class.border-wrong]="wrongName"
            [(ngModel)]="name"
            (input)="inputName()"
          >
          <button type="button" *ngIf="name !== ''" class="cross-clears" (click)="crossClearName()"></button>
          <span class="status" [class.status-error]="wrongName">{{ errorMessageName }}</span>
        </div>
      </div>
      <div class="del-type-delivery-middle-name">
        <label>По батькові</label>
        <div>
          <input
            type="text"
            placeholder="По батькові одержувача"
            [class.border-wrong]="wrongMiddleName"
            [(ngModel)]="middleName"
            (input)="inputMiddleName()"
          >
          <button type="button" *ngIf="middleName !== ''" class="cross-clears" (click)="crossClearMiddleName()"></button>
          <span class="status" [class.status-error]="wrongMiddleName">{{ errorMessageMiddleName }}</span>
        </div>
      </div>
      <div class="del-type-delivery-phone">
        <label>Телефон</label>
        <div>
          <input
            type="text"
            #phoneRef
            appPhoneMask
            [class.border-wrong]="wrongLastAddressPhone"
            [(ngModel)]="lastAddress.phone"
            (input)="inputLastAddressPhone()"
          >
          <button type="button" *ngIf="lastAddress.phone !== '' && !wrongLastAddressPhone" class="cross-clears" (click)="crossClearPhone()"></button>
          <span class="status-error" *ngIf="wrongLastAddressPhone">Введіть номер телефону</span>
        </div>
      </div>

      <div
        *ngIf="deliveryCurrent.working_details.will_be_transfer"
        class="del-type-date-limited"
      >
        <div>Дати відправлення обмежені в зв'язку з переміщенням з іншого складу</div>
      </div>

      <div class="del-type-date" *ngIf="deliveryCurrent.allow_delivery_dates">
        <label>
          Дата відправлення
        </label>
        <div *ngIf="dozakazDate" class="del-type-date-container">
          <small>Дозамовлення на дату: {{ dozakazDate }}</small>
          <ng-container *ngIf="dozakazDate === ''">
            <label *ngIf="!deliveryCurrent.allow_delivery_dates" class="alert">
              По прибуттю товару
            </label>
          </ng-container>
        </div>
        <div *ngIf="!dozakazDate">
          <select
            [class.border-wrong]="wrongDeliveryDates"
            [(ngModel)]="deliveryDate"
            (change)="onUserChangeDeliveryDate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryDates">Вкажіть дату відправлення</span>
        </div>
      </div>

      <div class="del-type-date" *ngIf="separateOrders && deliveryCurrent?.delivery_dates_zak?.length">
        <label>
          Дата відправки переміщення з іншого складу
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliverySeparate"
            [(ngModel)]="deliverySeparate"
            (change)="changingValueDeliverySeparate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates_zak" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status-error" *ngIf="wrongDeliverySeparate">Вкажіть дату відправлення</span>
        </div>
      </div>

      <div *ngIf="deliveryHoursList.length" class="del-type-date">
        <label>
          Час відправки
        </label>
        <div>
          <select [class.border-wrong]="wrongDeliveryHours"
                  [(ngModel)]="deliveryHours"
                  (change)="changingValueDeliveryHours()">
            <option value="-1">
              Виберіть час відправки
            </option>
            <option *ngFor="let hour of deliveryHoursList" [value]="hour">
              {{ hour }}:00
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryHours">Виберіть час відправки</span>
        </div>
      </div>

      <span class="message-otgrujaem"
            *ngIf="showMessageOtgrujaem">Включено відвантаження без оплати</span>
      <div class="del-type-user-comment">
        <label>Коментар до замовлення</label>
        <div>
          <textarea [(ngModel)]="deliveryComment"></textarea>
        </div>
      </div>

      <div class="del-type-send">
        <a routerLink="/basket">Редагувати замовлення</a>
        <div class="del-type-send-button">
          <app-order-in-progress-message [show]="showOrderInProgressMessage"/>
          <button class="button" [disabled]="isSendingPayment" (click)="sendPayment()">Відправити</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-message-delivery-dl-confirm/>











